import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportListaFuncionariosTUseCase } from "../../../presentation/useCases/read/get_report_lista_funcionarios_t_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportListaFuncionariosTUseCase implements IGetReportListaFuncionariosTUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportListaFuncionariosT(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportListaFuncionariosT(
      requiredMimeType,
    );

    if (response.mimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `Lista_Funcionarios_Terceirizados_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
